/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Received_AtInputs */

const en_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Received at`)
};

const de_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingegangen am`)
};

const fr_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu le`)
};

const es_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibida el`)
};

const it_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevuta il`)
};

const nl_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvangen op`)
};

const pl_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrzymano`)
};

const fi_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastaanotettu`)
};

const da_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modtaget`)
};

const sv_consumer_declaration_received_at = /** @type {(inputs: Consumer_Declaration_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mottagen`)
};

/**
* | output |
* | --- |
* | "Received at" |
*
* @param {Consumer_Declaration_Received_AtInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_received_at = /** @type {((inputs?: Consumer_Declaration_Received_AtInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Received_AtInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_received_at(inputs)
	if (locale === "fr") return fr_consumer_declaration_received_at(inputs)
	if (locale === "es") return es_consumer_declaration_received_at(inputs)
	if (locale === "it") return it_consumer_declaration_received_at(inputs)
	if (locale === "nl") return nl_consumer_declaration_received_at(inputs)
	if (locale === "pl") return pl_consumer_declaration_received_at(inputs)
	if (locale === "fi") return fi_consumer_declaration_received_at(inputs)
	if (locale === "da") return da_consumer_declaration_received_at(inputs)
	if (locale === "sv") return sv_consumer_declaration_received_at(inputs)
	return en_consumer_declaration_received_at(inputs)
});